import React, { useState, useEffect, useContext } from "react";
import * as Sentry from "@sentry/nextjs";
import ButtonUnstyled, {
  buttonUnstyledClasses,
} from "@mui/base/ButtonUnstyled";
import { styled } from "@mui/system";
import { makeStyles } from "@mui/styles";
import SnackBar from "../Common/SnackBar";
import auth from "../Layout/util/auth";
import Crypto from "../Payment/Crypto";
import { useMutation } from "react-query";
import fetcher from "../../src/dataProvider";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { setOpenKyc, setPaymentUrl } from "../../src/redux/slices/payment";
import { CommonContext } from "../helper/commonContext";
import TagManager from "react-gtm-module";
import cookie from "js-cookie";
import {
  Box,
  Button,
  ButtonBase,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Modal,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import {
  enquireNowGTMCTAClick,
  tokenPurchaseGTMCallback,
} from "../../util/gtmutil";

const useStyles = makeStyles((theme) => ({
  fantiger_info: {
    position: "relative",
    display: "block",
    width: "100%",
    maxWidth: "640px",
    background: "#242033",
    margin: "auto",
    padding: "40px 40px",
    borderRadius: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    "@media(max-width:767px)": {
      width: "90%",
      maxHeight: "515px",
      padding: "15px",
    },
  },
  descriptioncss: {
    position: "relative",
    display: "block",
    marginTop: "30px",
    "& h4": {
      fontSize: "18px",
      fontWeight: "700",
      marginBottom: "20px",
    },
    "& input": {
      border: "1px solid #928F99",
      borderRadius: "8px",
      display: "block",
      position: "relative",
      padding: "12px",
      color: "#928F99",
      background: "none",
      width: "100%",
    },
    "& p": {
      color: "#fff",
      marginBottom: "7px",
    },
  },

  paymentdetailscss: {
    left: "10px",
  },
  tottalPayment: {
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
  },
  title: {
    color: "#fff",
    marginBottom: "24px !important",
    fontWeight: "500 !important",
  },
  acceptTerm: {
    color: "#fff",
    fontSize: "14px",
    marginLeft: "5px",
    position: "relative",
    textAlign: "justify",
    padding: "0",
  },
  btnGradient: {
    position: "relative",
    textAlign: "center !important",
    display: "block !important",
    fontWeight: "600 !important",
    width: "48% !important",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB) !important",
    borderRadius: "10px !important",
    height: "56px !important",
    color: "#fff !important",
    textDecoration: "none !important",
    cursor: "pointer !important",
    textTransform: "capitalize !important",
    "&:hover": {
      color: "#fff !important",
      textDecoration: "none !important",
    },
  },
  btnOutlined: {
    position: "relative",
    textAlign: "center",
    display: "block !important",
    fontWeight: "600 !important",
    width: "48% !important",
    border: "1px solid #fff !important",
    borderRadius: "10px !important",
    height: "56px !important",
    color: "#fff !important",
    textTransform: "capitalize !important",
  },
}));

const CustomButtonRoot = styled("span")`
  font-family: Inter;
  font-weight: bold;
  font-size: 20px;
  display: flex;
  justify-content: center;
  padding: 6px;
  margin-top: 10px;
  background: linear-gradient(
    90.48deg,
    #e14084 3.73%,
    #3454fa 53.09%,
    #54b5bb 96.58%
  );
  border-radius: 8px;
  color: white;
  transition: all 150ms ease;
  cursor: pointer;
  border: none;
  width: 100%;
  margin: auto;
  text-align: center;

  &.${buttonUnstyledClasses.focusVisible} {
    box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1),
      0 0 0 5px rgba(0, 127, 255, 0.5);
    outline: none;
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

function CustomButton(props) {
  return <ButtonUnstyled {...props} component={CustomButtonRoot} />;
}

export default function AddNow(props) {
  const r = auth();
  console.log("Print props value addNow:", props);
  const { amount, text, paymentGateway } = props;
  const [open, setOpen] = React.useState(false);
  var router = useRouter();
  const commonContext = useContext(CommonContext);
  const dispatch = useDispatch();
  const handleClose = () => setOpen(false);
  const [fractoFormdata, setFractoFormdata] = useState(false);
  const [nftAction, setNftAction] = useState(
    typeof window !== "undefined" && localStorage.getItem("nftAction")
  );
  const [crypoData, setCrypoData] = useState({});
  const { country_code } = useSelector((state) => state.layout);
  const { userData } = useSelector((state) => state?.user);

  const [nftfinalPrice, setNftfinalPrice] = useState();
  const [currencytype, setCurrencytype] = useState();
  const [open1, setOpen1] = useState(false);
  const [agree, setAgree] = useState(true);
  const [cardNumber, setCardNumber] = useState();
  const [cvvNumber, setCvvNumber] = useState();
  const [expiryDate, setExpiryDate] = useState();
  const [expiryMonth, setExpiryMonth] = useState();
  const [loading, setLoading] = useState(false);
  const [fractoPaymentgateWay, setFractoPaymentgateWay] = useState();

  // credit card Number Verified

  const validateCardNumber = (number) => {
    var regex = new RegExp("^[0-9]{16}$");
    if (!regex.test(number)) return false;

    return luhnCheck(number);
  };

  const luhnCheck = (val) => {
    var sum = 0;
    for (var i = 0; i < val.length; i++) {
      var intVal = parseInt(val.substr(i, 1));
      if (i % 2 == 0) {
        intVal *= 2;
        if (intVal > 9) {
          intVal = 1 + (intVal % 10);
        }
      }
      sum += intVal;
    }
    return sum % 10 == 0;
  };

  const checkboxHandler = () => {
    setAgree(!agree);
  };

  const classes = useStyles();

  const handleClose1 = () => {
    setOpen1(false);
    props.handleClose2(false);
  };

  const handleOpen1 = () => {
    setOpen1(true);
  };

  const onClick = () => {
    console.log(
      "🚀 ~ file: AddNow.js ~ line 66 ~ onClick ~ sourcePaymentFlow",
      commonContext.sourcePaymentFlow
    );
    props.handleClose2(true);
    if (paymentGateway == "razorpay") {
      let paymentObject = {
        txnType: "credit",
        txnMode: "fiat",
        paymentGatewayProvider: "razorpay",
        currency: "USD",
        amount: amount,
        page:
          commonContext?.sourcePaymentFlow == "wallet"
            ? router?.asPath
            : "validate-payment",
      };
      handlerRazorpay(paymentObject);
      // GTM Tag for razorpay Add Funds
      const tagManagerArgs = {
        dataLayer: {
          event: "addFunds",
          tokenPrice: amount,
          paymentGatewayProvider: "razorpay",
          currency: "USD",
          userStatus: "loggedIn",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else if (paymentGateway == "stripe") {
      let paymentObject = {
        txnType: "credit",
        txnMode: "fiat",
        paymentGatewayProvider: paymentGateway,
        currency: "USD",
        amount: amount,
        page:
          commonContext?.sourcePaymentFlow == "wallet"
            ? router?.asPath
            : "validate-payment",
      };
      handleStripe(paymentObject);
      // GTM Tag for razorpay Add Funds
      const tagManagerArgs = {
        dataLayer: {
          event: "addFunds",
          tokenPrice: amount,
          paymentGatewayProvider: paymentGateway,
          currency: "USD",
          userStatus: "loggedIn",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else if (paymentGateway == "cashfree") {
      let paymentObject = {
        txnType: "credit",
        txnMode: "fiat",
        paymentGatewayProvider: paymentGateway,
        currency: "USD",
        amount: amount,
        page:
          commonContext?.sourcePaymentFlow == "wallet"
            ? router?.asPath
            : "validate-payment",
      };
      handleStripe(paymentObject);
      // GTM Tag for razorpay Add Funds
      const tagManagerArgs = {
        dataLayer: {
          event: "addFunds",
          tokenPrice: amount,
          paymentGatewayProvider: paymentGateway,
          currency: "USD",
          userStatus: "loggedIn",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else if (paymentGateway == "easebuzz") {
      let paymentObject = {
        txnType: "credit",
        txnMode: "fiat",
        paymentGatewayProvider: paymentGateway,
        currency: "USD",
        amount: amount,
        page:
          commonContext?.sourcePaymentFlow == "wallet"
            ? router?.asPath
            : "validate-payment",
        deviceInfo: { source: "website" },
      };
      handleEasebuzz(paymentObject);
      // GTM Tag for easebuzz Add Funds
      const tagManagerArgs = {
        dataLayer: {
          event: "addFunds",
          tokenPrice: amount,
          paymentGatewayProvider: paymentGateway,
          currency: "USD",
          userStatus: "loggedIn",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };

  const { mutate: addUserPaymentLog } = useMutation(
    (logData) => fetcher.post("/v1/user/log", logData),
    {
      onSuccess: (response) => {
        console.log("success log: ", response);
      },
      onError: (error) => {
        console.log("fail log: ", error);
      },
    }
  );

  const { mutate: handleStripe } = useMutation(
    (paymentObject) => fetcher.post(`v1/wallet/create-order`, paymentObject),
    {
      onSuccess: (res) => {
        localStorage.setItem("PaymentLink", res.paymentLink);
        dispatch(setPaymentUrl(res.paymentLink));
        window.location.replace(res.paymentLink);
      },
      onError: (error) => {
        Sentry.captureException(error);
        Sentry.captureException("Insufficien t fund");
        console.log("Error message Print ===", error);
        alert(error?.response?.data?.message);
      },
    }
  );

  // easebuzz payment gateway handle

  const invokeEasebuzz = (data) => {
    var easebuzzCheckout = new EasebuzzCheckout("D4Q8T3VAWP", "prod");
    var options = {
      access_key: data, // access key received via Initiate Payment
      onResponse: (response) => {
        console.log("Print invokeEasebuzz ", response);
        localStorage.setItem("PaymentLink", response?.surl);
        dispatch(setPaymentUrl(response?.surl));
        if (response?.status == "success") {
          commonContext.setPaymentSuccessModel(true);
          walletBalance();
          router.push(`wallet?orderId=${response?.txnid}`);
        } else if (response?.status != "userCancelled") {
          walletBalance();
          router.push(`wallet?orderId=${response?.txnid}`);
        }
      },
      theme: "#123456", // color hex
    };
    easebuzzCheckout.initiatePayment(options);
  };

  const { mutate: handleEasebuzz } = useMutation(
    (paymentObject) => fetcher.post(`v1/wallet/create-order`, paymentObject),
    {
      onSuccess: (res) => {
        invokeEasebuzz(res?.data);
      },
      onError: (error) => {
        Sentry.captureException(error);
        Sentry.captureException("Insufficien t fund");
        console.log("Error message Print ===", error);
        alert(error?.response?.data?.message);
      },
    }
  );

  const { mutate: handlerRazorpay } = useMutation(
    (paymentObject) => fetcher.post(`v1/wallet/create-order`, paymentObject),
    {
      onSuccess: (res) => {
        initiateRazorpay(res?.orderId, res?.amount);
      },
      onError: (error) => {
        Sentry.captureException(error);
        console.log("Error message Print ===", error.response.data.message);
        alert(error?.response?.data?.message);
      },
    }
  );

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  useEffect(() => {
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (country_code == "IN") {
      setNftfinalPrice(amount * 80);
      setCurrencytype("INR");
    } else {
      setNftfinalPrice(amount);
      setCurrencytype("USD");
    }
  });
  const [snackbar, setSnackbar] = useState({
    show: false,
    status: "",
    message: "",
  });

  const toggleSnackbar = (value) => {
    setSnackbar(value);
  };
  var email;
  var userName;

  const initiateRazorpay = (orderId, amountInPaise) => {
    if (typeof window !== "undefined") {
      email = localStorage.getItem("userEmailID");
      userName = localStorage.getItem("userName");
    }
    try {
      const options = {
        key: process.env.NEXT_PUBLIC_RAZORPAY_CLIENT_ID,
        currency: "USD",
        international: true,
        name: "FanTiger",
        handler: razorPayHandler,
        modal: {
          ondismiss: razorPayDismissHandler,
        },
        theme: {
          color: "#4994d3",
        },
        order_id: orderId,
        amount: amountInPaise,
        description: "Add  funds  in  wallet",
        prefill: {
          name: userName,
          email: email,
        },
        notify: {
          sms: true,
          email: true,
        },
      };

      const rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", (response) => {
        let logData = {
          type: "razorpay-payment-failed",
          log: {
            data: response || "Data was not returned from razorpay",
          },
        };
        addUserPaymentLog(logData);
      });

      rzp1.open();
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
      setSnackbar({
        show: true,
        status: "error",
        message: "Something went wrong while making payment",
      });
    }
  };
  const { mutate: verifyRazorPayment } = useMutation((data) =>
    fetcher.post(`v1/wallet/validate-razorpay-payment`, data)
  );
  const razorPayHandler = (data) => {
    let logData = {
      type: "razorpay-handler-data",
      log: {
        data: data || "Data was not returned from razorpay",
      },
    };
    addUserPaymentLog(logData);
    try {
      if (!data.razorpay_payment_id) {
        setSnackbar({
          show: true,
          status: "error",
          message: "Razorpay payment id not found",
        });
      } else {
        let paymentObject = {
          razorpayPaymentId: data.razorpay_payment_id,
          razorpayOrderId: data.razorpay_order_id,
          razorpaySignature: data.razorpay_signature,
        };
        verifyRazorPayment(paymentObject, {
          onSuccess: (res) => {
            if (res.paymentStatus == "SUCCESS") {
              walletBalance();
              if (commonContext?.sourcePaymentFlow == "ReserveNFT") {
                if (typeof window != "undefined") {
                  var requestBody = {
                    tierId: localStorage.getItem("tierId"),
                    quantity: localStorage.getItem("quantity"),
                  };
                  ReserveNFT(requestBody);
                }
              } else if (commonContext?.sourcePaymentFlow == "wallet") {
                commonContext?.setPaymentSuccessModel(true);
              } else if (commonContext?.sourcePaymentFlow == "BuyNFT") {
                if (typeof window != "undefined") {
                  var requestBody = {
                    tierId: localStorage.getItem("tierId"),
                    quantity: localStorage.getItem("quantity"),
                  };
                  BuyNFT(requestBody);
                  // ConfirmNFT(requestBody);
                  // router.push(`/validate-payment?status=${res.paymentStatus}`);
                }
              }
            } else {
              router.push(`/validate-payment?status=${res.paymentStatus}`);
            }
          },
          onError: (err) => {
            Sentry.captureException(error);
            console.log(
              "🚀 ~ file: AddNow.js ~ line 254 ~ razorPayHandler ~ Erroreeeee",
              err
            );

            router.push("/validate-payment?status=FAILED");
          },
        });
      }
    } catch (error) {
      Sentry.captureException(error);
      setSnackbar({
        show: true,
        status: "error",
        message: "Something went wrong while confirming payment",
      });
    }
  };

  const { mutate: walletBalance } = useMutation(
    () =>
      fetcher.get(`v1/wallet/balance`, {
        params: {
          [`sortBy`]: "createdAt",
        },
      }),
    {
      onSuccess: (res) => {
        commonContext?.setWalletBalance(res.balance);
        typeof window != "undefined" &&
          localStorage.setItem("walletBalance", res.balance);
      },
    }
  );
  const { mutate: ConfirmNFT } = useMutation(
    (requestBody) => fetcher.post(`v1/nft/buy`, requestBody),
    {
      onSuccess: (res) => {
        if (res.message == "success") {
        }
        router.push("/profile");
      },
      onError: (error) => {
        Sentry.captureException(error.response.data);
        Sentry.captureException(new Error(error.response.data));
        // alert(error.response.data.message);
        console.log("Error message Print ===", error);
      },
    }
  );
  const { mutate: BuyNFT } = useMutation(
    (requestBody) => fetcher.post(`v1/nft/buy`, requestBody),
    {
      onSuccess: (res) => {
        if (res.message == "success") {
          const user = auth();
          console.log("auth", user?.userId);
          if (res?.isFirstPurchase === true) {
            tokenPurchaseGTMCallback(
              r,
              "first_purchase",
              "SUCCESS",
              paymentGateway,
              "USD",
              nftfinalPrice,
              props?.tokenCategory,
              props?.tokenOwnership,
              "First_" + "" + res?.orderId,
              userData?.phone,
              userData?.email,
              cookie?.get("_gid"),
              localStorage.getItem("quantity")
            );
          }
          const tagManagerArgs = {
            dataLayer: {
              event: "purchase",
              paymentStatus: "SUCCESS",
              paymentGateway: paymentGateway,
              currency: currencytype.toUpperCase(),
              ecommerce: {
                purchase: {
                  actionField: {
                    id: user?.userId, // Transaction ID. Required for purchases and refunds.
                    affiliation: "webSite",
                    revenue: nftfinalPrice,
                    tax: 0,
                    shipping: 0,
                    coupon: 0,
                  },
                  products: [
                    {
                      name: props?.tokenCategory, // Name or ID is required.
                      id: props?.tokenCategory,
                      price: nftfinalPrice,
                      brand: "FanTiger",
                      category: props?.tokenCategory,
                      variant: props?.tokenOwnership,
                      quantity: 1,
                      coupon: 0,
                    },
                  ],
                },
              },
            },
          };
          TagManager.dataLayer(tagManagerArgs);

          router.push(`/validate-payment?status=SUCCESS`);
        } else {
          router.push(`/validate-payment?status=FAILED`);
        }
      },
      onError: (error) => {
        alert(error.response.data.message);
        console.log("Error message Print ===", error);
      },
    }
  );

  const { mutate: ReserveNFT } = useMutation(
    (requestBody) => fetcher.post(`v1/nft/reserve`, requestBody),
    {
      onSuccess: (res) => {
        router.push("/profile");
      },
      onError: (error) => {
        Sentry.captureException(error);
        alert(error.response.data.message);
        console.log("Error message Print ===", error);
      },
    }
  );

  // HANDLE FRACTO PAYMENT GATEWAY
  const { mutate: handleFracto } = useMutation(
    (paymentObject) => fetcher.post(`v1/wallet/fracto-payment`, paymentObject),
    {
      onSuccess: (res) => {
        localStorage.setItem("PaymentLink", res.paymentLink);
        dispatch(setPaymentUrl(res.paymentLink));
        setFractoPaymentgateWay(res);
        setCardNumber("");
        setExpiryDate("");
        setExpiryMonth("");
        walletBalance();
        if (r?.token) {
          const tagManagerArgs = {
            dataLayer: {
              event: "addFunds",
              amount: amount,
              paymentGatewayProvider: res?.paymentGatewayProvider,
              currency: "USD",
              userStatus: "loggedIn",
              mobile: userData?.mobile,
              email: userData?.email,
              gaID: cookie.get("_gid"),
            },
          };
          TagManager.dataLayer(tagManagerArgs);
        } else {
          const tagManagerArgs = {
            dataLayer: {
              event: "addFunds",
              amount: amount,
              paymentGatewayProvider: res?.paymentGatewayProvider,
              currency: "USD",
              userStatus: "Guest",
              mobile: userData?.mobile,
              email: userData?.email,
              gaID: cookie.get("_gid"),
            },
          };
          TagManager.dataLayer(tagManagerArgs);
        }
        if (res.paymentStatus == "FAILED") {
          handleClose1();
          handleClose;
          alert("payment failed, something went wrong!");
        } else {
          commonContext.setPaymentSuccessModel(true);
          router.push(
            commonContext?.sourcePaymentFlow == "wallet" && "/wallet"
          );
          handleClose1();
          handleClose;
        }
      },
      onError: (error) => {
        console.log("Error message Print ===", error);
        // router.push("/validate-payment?status=FAILED");
        setLoading(false);
        alert(error?.response?.data?.message);
      },
    }
  );

  const razorPayDismissHandler = () => {
    let logData = {
      type: "razorpay-handler",
      log: {
        message: "Payment was cancelled",
      },
    };
    addUserPaymentLog(logData);
    setSnackbar({
      show: true,
      status: "warning",
      message: "Payment was not completed",
    });
    Sentry.captureException("Razor pay Modal Closed");
  };

  const handlenftUSAPay = () => {
    enquireNowGTMCTAClick(r, "ctaClicks", "loggedIn", "Guest", "Confirm & Pay");
    const finalExpiryDateMM = expiryMonth + expiryDate;
    let paymentObject = {
      currency: "USD",
      amount: amount.toString(),
      type: "card",
      ccnumber: cardNumber,
      ccexp: finalExpiryDateMM,
      cvv: cvvNumber,
      deviceInfo: { source: "website" },
    };
    if (
      validateCardNumber(cardNumber) &&
      cardNumber &&
      finalExpiryDateMM &&
      cvvNumber &&
      cvvNumber?.length == 3
    ) {
      setFractoFormdata(true);
      setLoading(true);
      handleFracto(paymentObject);
    } else {
      setFractoFormdata(false);
    }
  };

  const handleEnter = (event) => {
    if (event.key.toLowerCase() === "enter") {
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  };

  const validateInput = (event) => {
    if (event.target.value.length > 1) {
      const form = event.target.form;
      const index = [...form].indexOf(event.target);
      form.elements[index + 1].focus();
      event.preventDefault();
    }
  };

  console.log("loading Value:", loading);

  return (
    <>
      <CustomButton
        onClick={() => {
          country_code == "IN" ? onClick() : handleOpen1();
        }}
        {...props}
      >
        {props.text}
      </CustomButton>
      <Crypto open={open} onClose={handleClose} crypoData={crypoData} />
      {snackbar.show ? (
        <SnackBar {...snackbar} onClose={toggleSnackbar} />
      ) : null}

      <Modal open={open1} onClose={handleClose1} disableScrollLock={true}>
        <Box className={classes.fantiger_info}>
          <button
            type="button"
            className={classes.close + " close"}
            data-dismiss="modal"
            aria-label="Close"
            onClick={handleClose1}
          >
            <span aria-hidden="true">
              <img src="/images/white-close.svg" width="24px" />
            </span>
          </button>

          <Box>
            <Box>
              <Typography variant="h5" className={classes.title}>
                Pay by card
              </Typography>
              <Divider
                style={{
                  width: "100%",
                  border: "1px solid #fff",
                  opacity: "0.5",
                }}
              />

              <Box className={classes.descriptioncss}>
                <Box className="callout margin-top50">
                  <form onSubmit={() => handlenftUSAPay()}>
                    <Box style={{ width: "100%", marginBottom: "24px" }}>
                      <Typography component="p">Card Number </Typography>
                      <input
                        type="text"
                        maxLength="16"
                        onChange={(e) => setCardNumber(e?.target?.value)}
                        placeholder="card number"
                      />
                      {validateCardNumber(cardNumber) == false && (
                        <>
                          <div
                            style={{
                              color: "red",
                              marginTop: "3px",
                              textAlign: "left",
                            }}
                          >
                            Please enter correct Card Number
                          </div>
                        </>
                      )}
                    </Box>
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box style={{ width: "48%", marginBottom: "24px" }}>
                        <Typography component="p">Expiry </Typography>
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <input
                            type="text"
                            onChange={(e) => setExpiryMonth(e?.target?.value)}
                            placeholder="MM"
                            maxLength="2"
                            style={{ width: "48%" }}
                            onKeyDown={handleEnter}
                            name={"ExpiryDate"}
                            onKeyUp={(e) => {
                              validateInput(e);
                            }}
                          />
                          <Typography
                            component="span"
                            style={{
                              width: "20px",
                              color: "#fff",
                              textAlign: "center",
                              fontSize: "24px",
                            }}
                          >
                            /{" "}
                          </Typography>
                          <input
                            type="text"
                            onChange={(e) => setExpiryDate(e?.target?.value)}
                            placeholder="YY"
                            maxLength="2"
                            style={{ width: "48%" }}
                            onKeyDown={handleEnter}
                            onKeyUp={(e) => {
                              validateInput(e);
                            }}
                            name={"ExpiryYear"}
                          />
                        </Box>
                        {!expiryDate && (
                          <>
                            <div
                              style={{
                                color: "red",
                                marginTop: "3px",
                                textAlign: "left",
                              }}
                            >
                              Please enter expire date
                            </div>
                          </>
                        )}
                      </Box>
                      <Box style={{ width: "48%", marginBottom: "24px" }}>
                        <Typography component="p"> CVV </Typography>
                        <input
                          type="text"
                          maxLength="3"
                          onChange={(e) => setCvvNumber(e?.target?.value)}
                          placeholder="CVV"
                          name={"CVV"}
                        />
                        {!cvvNumber && cvvNumber?.length != 3 && (
                          <>
                            <div
                              style={{
                                color: "red",
                                marginTop: "3px",
                                textAlign: "left",
                              }}
                            >
                              Please enter cvv
                            </div>
                          </>
                        )}
                      </Box>
                    </Box>
                  </form>
                </Box>
              </Box>
              <Box
                style={{
                  color: "#fff",
                  marginBottom: "7px",
                  fontSize: "12px",
                  fontWeight: "400",
                }}
              >
                Powered by{" "}
                <Box
                  component="img"
                  src="/images/payment/Fraclogo.svg"
                  style={{
                    width: "50px",
                    marginLeft: "2px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    enquireNowGTMCTAClick(
                      r,
                      "ctaClicks",
                      "loggedIn",
                      "Guest",
                      "Fracto Logo"
                    );
                    window.open("https://frac.to/", "_blank");
                  }}
                />
              </Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <input
                  type="checkbox"
                  style={{
                    width: "15px",
                    top: "6px",
                    position: "relative",
                    cursor: "pointer",
                  }}
                  id="agree"
                  defaultChecked={agree}
                  onChange={checkboxHandler}
                />
                <Box className={classes.acceptTerm}>
                  I agree to{" "}
                  <Typography
                    component="span"
                    style={{
                      cursor: "pointer !important",
                      color: "#e14084",
                    }}
                    onClick={() => window.open("/terms", "_blank")}
                  >
                    T&#38;C{" "}
                  </Typography>
                  and{" "}
                  <Typography
                    component="span"
                    style={{
                      zIndex: 1000,
                      cursor: "pointer",
                      color: "#e14084",
                    }}
                    onClick={() => window.open("/privacy", "_blank")}
                  >
                    Privacy Policy{" "}
                  </Typography>
                  and to receive communication &#47;notifications on email &#47;
                  WhatsApp &#47;SMS from FanTiger.{" "}
                </Box>
              </Box>
              <Divider
                style={{
                  width: "100%",
                  border: "1px solid #fff",
                  opacity: "0.5",
                  margin: "24px 0",
                }}
              />

              <Box
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  onClick={() => handleClose1()}
                  className={classes.btnOutlined}
                >
                  Back
                </Button>
                {loading ? (
                  <Button className={classes.btnGradient}>
                    <CircularProgress style={{ color: "white" }} size={20} />
                  </Button>
                ) : (
                  <Button
                    onClick={() => handlenftUSAPay()}
                    className={classes.btnGradient}
                    disabled={fractoFormdata ? true : false}
                  >
                    Confirm & Pay
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

// const handleCrypto = () => {
//   var myHeaders = new Headers();
//   myHeaders.append("Content-Type", "application/json");
//   const user = auth();

//   var raw = JSON.stringify({
//     paymentDetails: {
//       principalAmount: props.amount,
//       currency: "USD",
//     },
//     pricingType: "fixed_price",
//     customer: {
//       customerId: user.id,
//       customerName: user.email,
//     },
//   });

//   var requestOptions = {
//     method: "POST",
//     headers: myHeaders,
//     body: raw,
//     redirect: "manual",
//   };

//   fetch(
//     "/pay/api/wallet/addmoney",
//     requestOptions
//   )
//     .then((response) => response.json())
//     .then((result) => {
//       setCrypoData(result);
//       handleOpen();
//     })
//     .catch((error) => console.log("error", error));
// };

// {
//   onSuccess: (res) => {
//   console.log("🚀 ~ file: AddNow.js ~ line 254 ~ razorPayHandler ~ ressssssss", res)
//   console.log("🚀 ~ file: AddNow.js ~ line 254 ~ razorPayHandler ~ commonContext?.sourcePaymentFlow", commonContext?.sourcePaymentFlow)
//     if(res.paymentStatus=='SUCCESS'){
//        walletBalance()
//       if(commonContext?.sourcePaymentFlow=="ReserveNFT"){
//         router.push(`/validate-payment?status=${res.paymentStatus}`)
//       }else{
//         walletBalance()
//         alert("Buy NFT Api will Call")
//         // BuyNFT()
//       commonContext?.setPaymentSuccessModel(true)
//       }
//     }else{
//       if(commonContext?.sourcePaymentFlow=="ReserveNFT"){
//         router.push(`/validate-payment?status=${res.paymentStatus}`)
//       }else{
//      console.log("erro")
//       }
//     }
//   },
//   onError: (err) => {
//     console.log("🚀 ~ file: AddNow.js ~ line 254 ~ razorPayHandler ~ Erroreeeee", res)
//     router.push('/validate-payment?status=FAILED')
//   },
// });
